export function decodeData (data) {
  let rs
  try {
    rs = decodeURIComponent(data)
  } catch (error) {
    rs = data
  }

  return rs
}
